import Sidebar from "../../components/Sidebar";
import React, { useState, useEffect } from "react";
import { useUser } from "../../context/userContext";
import axios from "axios";
import OrderTable from "../../components/deliveries/orderTable";
import PreviewOrderModal from "../../components/deliveries/previewOrderModal"; // Import the preview modal
import EditOrderModal from "../../components/deliveries/editOrderModal"; // Import the edit modal

const Deliveries = () => {
  const [orders, setOrders] = useState([]); // Orders list state
  const { user } = useUser(); // User context
  const [isPreviewModalOpen, setPreviewModalOpen] = useState(false); // Preview modal state
  const [isEditModalOpen, setEditModalOpen] = useState(false); // Edit modal state
  const [selectedOrder, setSelectedOrder] = useState(null); // Order selected for preview/edit
  const [currentPage, setCurrentPage] = useState(1); // Pagination state
  const ordersPerPage = 10;

  // Pagination calculations
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = orders.slice(indexOfFirstOrder, indexOfLastOrder);
  const totalPages = Math.ceil(orders.length / ordersPerPage);

  // Pagination handler
  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  // Preview modal handler
  const handlePreviewModalOpen = (order) => {
    setSelectedOrder(order);
    setPreviewModalOpen(true);
  };

  // Edit modal handler
  const handleEditModalOpen = (order) => {
    setSelectedOrder(order);
    setEditModalOpen(true);
  };

  // Fetch orders from the API
  useEffect(() => {
    if (user?.id) {
      fetchOrders();
    }
  }, [user]);

  const fetchOrders = async () => {
    try {
      const response = await axios.get(`https://api.theonlysale.com/api/order/get`);
      setOrders(response.data);
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  return (
    <>
     <div className="flex flex-col min-h-screen sm:flex-row">
     {/* Sidebar */}
        <div className="sm:w-64 w-full">
        <Sidebar />
        </div>

        <div className="flex-grow dark:bg-gray-900 p-4">
        <OrderTable
  currentOrders={currentOrders}
  indexOfFirstOrder={indexOfFirstOrder}
  indexOfLastOrder={indexOfLastOrder}
  ordersLength={orders.length}
  totalPages={totalPages}
  currentPage={currentPage}
  handlePageChange={handlePageChange}
  handlePreviewModalOpen={handlePreviewModalOpen}
  handleEditModalOpen={handleEditModalOpen}
/>

        </div>

        <PreviewOrderModal
          isPreviewModalOpen={isPreviewModalOpen}
          togglePreviewModal={() => setPreviewModalOpen(!isPreviewModalOpen)}
          selectedOrder={selectedOrder}
          fetchOrders={fetchOrders}
        />

        <EditOrderModal
          isEditModalOpen={isEditModalOpen}
          toggleModal={() => setEditModalOpen(!isEditModalOpen)}
          orderId={selectedOrder?.order_id} // Pass the order ID
          fetchOrders={fetchOrders} // Refetch orders after editing
        />
      </div>
    </>
  );
};

export default Deliveries;
